import { InputWrapper, MOBILE_HEADER_HEIGHT, mobileButtonBackgroundCSS } from '@talos/kyoko';
import { PropertyButton } from '@talos/kyoko/src/components/Filters/FilterBuilder/styles';
import styled from 'styled-components';
import { MOBILE_HEADER_TOP_OFFSET_DEFAULT, MOBILE_HEADER_TOP_OFFSET_PROPERTY } from '../../../mobileHeaderOffset';

export const MobileBlotterSheetSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing8}px;
`;

export const MobileFilterBuilderWrapper = styled.div`
  ${PropertyButton} {
    justify-content: flex-start;
  }

  [data-testid='filter-builder-content'] {
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
    gap: ${({ theme }) => theme.spacing8}px;
  }

  [data-testid='add-filter-button'] {
    width: 100%;
    justify-content: center;
  }
`;

export const MobileBlotterSheetActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing8}px;
  padding-bottom: ${({ theme }) => theme.spacing8}px;
`;

export const MobileBlotterSearchBar = styled.div`
  position: fixed;
  top: calc(var(${MOBILE_HEADER_TOP_OFFSET_PROPERTY}, ${MOBILE_HEADER_TOP_OFFSET_DEFAULT}) + ${MOBILE_HEADER_HEIGHT}px);
  right: 0;
  left: 0;
  z-index: 999;

  ${InputWrapper} {
    border-radius: 16px;
    ${mobileButtonBackgroundCSS}
  }
`;
